import { render, staticRenderFns } from "./CustomerContractPlanHistory.vue?vue&type=template&id=06d256ae"
import script from "./CustomerContractPlanHistory.vue?vue&type=script&lang=js"
export * from "./CustomerContractPlanHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports